/* eslint-disable no-unused-vars */
import TextField from '@material-ui/core/TextField';
import createComponent from '../createComponent';
import mapError from '../mapError';

// eslint-disable-next-line func-names
export default createComponent(TextField, ({ defaultValue, ...props }) => ({ ...mapError(props) }));
